import styled from 'styled-components';

export const CardWrapper = styled.div`
  height: 50px;
  width: 170px;
  margin: 0 auto;
  font-size: xx-large;
  text-align: center;
`;

export const FormControlWrapper = styled.div`
  display: flex;
  width: 160px;
  margin: 0 auto;
  align-content: center;
  justify-content: center;
`;

export const CenteredFlexDevWrapper = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
`;

export const FormWrapper = styled.div`
  .myFormClass {
    display: flex;
    align-content: center;
    justify-content: center;
    width: 160px;
    margin: 0 auto;
  }
`;
